import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Tooltip} from "@mui/material";

// core components
import Badge from "components/Badge";

// style
import {black500} from "assets/jss/main";

ValidReferencesCount.propTypes = {
    retailer: PropTypes.object.isRequired,
};

function renderPercentage(percentage) {
    if (percentage === 0 || percentage === undefined || percentage === null) {
        return null;
    }

    // Pour les valides : une hausse est positive (success), une baisse est négative (error)
    const color = percentage > 0 ? 'online' : 'error';
    const label = `${percentage > 0 ? '+' : ''}${percentage}%`;

    return (
        <Tooltip title={<FormattedMessage id="retailer.list.stats.variationPeriod.tooltip" />}>
            <span><Badge color={color} label={label} size={'small'} /></span>
        </Tooltip>
    );
}

function ValidReferencesCount({retailer}) {
    const productCount = retailer.validProductCount || 0;
    const variationCount = retailer.validVariationCount || 0;
    const productPercentage = retailer.validProductCountVariationPercentage;
    const variationPercentage = retailer.validVariationCountVariationPercentage;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '14px',
                fontWeight: 600,
                color: black500,
                whiteSpace: 'nowrap',
            }}>
                <FormattedMessage id="retailer.list.table.body.products" values={{count: productCount.toLocaleString('fr-FR')}} />
                {renderPercentage(productPercentage)}
            </div>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '12px',
                color: black500,
                whiteSpace: 'nowrap',
            }}>
                <FormattedMessage id="retailer.list.table.body.variations" values={{count: variationCount.toLocaleString('fr-FR')}} />
                {renderPercentage(variationPercentage)}
            </div>
        </div>
    );
}

export default ValidReferencesCount;
